import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, combineLatest, EMPTY, NEVER, Observable, ObservedValueOf, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { APP_BASE_HREF } from '@angular/common';
import Url from 'url-parse';

import { EveReportingWidgetDataSource, EveReportingWidgetDataSourceType } from '../../components/widgets/widget-menu-settings/widget-datasource/widget-datasource.component';

import { ControlWidgetService } from '../ControlWidgetService.service';
import { GraphQlQueryExecutor } from '../../operators/graphql/query-executor/graphql-query-executor.operator';
import { GraphQlQueryResultToNgxMulti } from '../../operators/graphql/query-result-to-ngx-multi/graphql-query-result-to-ngx-multi.operator';
import { EveInternal } from '../../operators/eve/interval/eve-interval.operator';
import { EveReportingWidget } from '../../components/widgets/widget.component';
import { iDataSource } from './IDataSourceService.service';
import { Single } from '../../interfaces/single.interface';

import { EveReportingWidgetSingleDataSource } from '../../components/widgets/widget-menu-settings/widget-datasource/widget-single-datasource/widget-single-datasource.component';
import { GraphQLComparision } from '../../enums/GraphQLComparision.enum';
import { GraphQLFilter, GraphQlQuery, IGraphQlService } from '../GraphQl/IGraphQL.service';
import { IVisibilityStateService } from '../VisibilityState/IVisibilityState.service';

@Injectable()
export class EveSingleDataSourceService {
  constructor(
    public graphQlService: IGraphQlService,
    public controlWidgetService: ControlWidgetService,
    public visibilityStateService: IVisibilityStateService
  ) { }


  

  EveSingleDataSourceResults(widget: EveReportingWidget): Observable<Single[]>  {
    
    const dataSource = ((widget as any) as iDataSource)?.dataSource as EveReportingWidgetSingleDataSource;
    const wheres: Observable<any[]> = dataSource.wheres?.length > 0 ? combineLatest.apply(null, dataSource.wheres.map(w => of(w).pipe(
      switchMap(where => {
        if (where.isControlWidget == false) {
          return of(w)
        }
        else {
          return this.controlWidgetService.controlWidgets.pipe(
            switchMap(widgets => widgets.find(w => w.controlWidgetId != where.value)?.controlValue ?? of("")),
            map(value => ({
              path: where.path,
              comparison: where.comparison,
              value: where.comparison == GraphQLComparision.IN ? value : value.toString()
            }) as GraphQLFilter)
          );
        }
      })
    ))) : of([]);



    var groupBys = [];
    //if (widget.widgetType == EveReportingWidgetType.pieChart) {
    //  groupBys = [
    //    { path: dataSource.legend },
    //  ]
    //}

    groupBys = [
      { path: dataSource.legend },
    ]

    return wheres.pipe(
      map(wheres => ({
        dataset: dataSource.queryField,
        selects: [
          {
            field: dataSource.value
          },
          {
            field: dataSource.legend
          }
        ],
        wheres: wheres,
        
        groupBys: groupBys,
        

        page: 0,
        pageSize: -1
      } as GraphQlQuery))
    ).pipe(
      /*tap(() => this.isLoading.emit(true)),*/
      GraphQlQueryExecutor(of(this.graphQlService)),
      EveInternal(5000, this.visibilityStateService.VisibilityState()),
      GraphQlQueryResultToNgxMulti(),
      map(multi => multi[0].series),
      
     
      catchError(ex => {
        console.log(JSON.stringify(ex));
        //this.isLoading.emit(false);
        //this.hasErrored.emit(true);
        return NEVER;
      }),
      tap(() => {
        //this.isLoading.emit(false);
        //this.hasErrored.emit(false);
      }),
      //startWith(null)
    );
        
        
  }
}

